export default "__VITE_ASSET__849ae788__"